const UA = () => (typeof navigator === "undefined" ? "" : navigator.userAgent || "");

export const isInApp = () => /Instagram|FBAN|FBAV|FB_IAB|FBIOS|FB4A/i.test(UA());
export const isAndroid = () => /Android/i.test(UA());

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

// Same radar + its UTM, to reopen in the system browser.
export function radarUrl(radarId, attribution) {
  const q = new URLSearchParams();
  if (radarId) q.set("radar", radarId);
  UTM_KEYS.forEach((k) => attribution?.[k] && attribution[k] !== "directe" && q.set(k, attribution[k]));
  return `${window.location.origin}/?${q.toString()}`;
}

// Android: intent:// to Chrome (fallback = same https URL). iOS: x-safari-https:// (iOS 17+), plus a text fallback.
export function systemBrowserLink(url) {
  const u = new URL(url);
  if (isAndroid()) {
    return `intent://${u.host}${u.pathname}${u.search}#Intent;scheme=https;package=com.android.chrome;S.browser_fallback_url=${encodeURIComponent(url)};end`;
  }
  return `x-safari-https://${u.host}${u.pathname}${u.search}`;
}
